import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {ContractDto} from "../../../../../model/dto/entity/contract.dto";
import {CustomerDto} from "../../../../../../cr/model/dto/entity/customer.dto";
import {ObjectIdentifier} from "../../../../../../../core/shared/basic/object-identifier";
import {DtoDetail} from "../../../../../../../core/shared/dto/dto.detail";

@Component({
    selector: 'cm-shared-component',
    templateUrl: './cm-shared.component.html',
    standalone: false
})
export class CmSharedComponent implements OnInit, OnChanges, OnDestroy {
    @Input() objectIdentifier: ObjectIdentifier;
    @Input() contract: ContractDto | DtoDetail;
    @Input() customer: CustomerDto | DtoDetail;
    busy: boolean;  // indicator whether the component is busy
    initialized: boolean; // indicator whether the component was initialized

    constructor() {
    }

    ngOnInit(): void {
        this.initComponent();

    }

    /**
     * Initialize Component.
     */
    initComponent() {
        this.refreshComponent();
    }

    /**
     * Refresh Component.
     */
    refreshComponent() {
        this.initialized = true;
    }

    /**
     * Process changes within Binding.
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {

        if (!this.initialized) {
            return;
        }

        if (changes["id"]) {
            this.refreshComponent();
        }
    }

    /**
     * Destroy component.
     */
    ngOnDestroy(): void {

    }
}
